import { AppointmentFormData } from '../../types'

const toSafeString = (value: any) => value ?? ''

// Needed because React doesn't like when we set form values to undefined or null.
// It throws warnings about controlled and uncontrolled otherwise.
const toSafeFormData = (appointment: AppointmentFormData): AppointmentFormData =>
  Object.entries(appointment).reduce<AppointmentFormData>(
    (acc, [key, value]) => ({
      ...acc,
      [key]: ['clientStartDate', 'clientStartTime', 'start_date'].includes(key) ? value : toSafeString(value),
    }),
    {}
  )

export { toSafeFormData }
